import clsx from 'clsx';
import { type CardType } from '../../sections/press-media/AllPressCoverage/pressdata';
import {
  BookOpenIcon,
  DocumentTextIcon,
  MegaphoneIcon,
  TrophyIcon,
  UsersIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';

export const typePillPropertyMap: Record<CardType, { color: string; icon: React.ReactNode }> = {
  Partnership: { color: 'border-[#169A4B] text-[#169A4B]', icon: <UsersIcon className="size-6 text-[#169A4B]" /> },
  Award: { color: 'border-gradle-blue text-gradle-blue', icon: <TrophyIcon className="size-6 text-gradle-blue" /> },
  'Media Coverage': {
    color: 'border-[#FF51A2] text-[#FF51A2]',
    icon: <VideoCameraIcon className="size-6 text-[#FF51A2]" />,
  },
  Announcement: { color: 'border-[#CE58F9] text-[#CE58F9]', icon: <MegaphoneIcon className="size-6 text-[#CE58F9]" /> },
  Research: { color: 'border-[#F3892C] text-[#F3892C]', icon: <DocumentTextIcon className="size-6 text-[#F3892C]" /> },
  Whitepaper: {
    color: 'border-gradle-blue text-gradle-blue',
    icon: <DocumentTextIcon className="size-6" />,
  },
  Ebook: { color: 'border-core-success text-core-success', icon: <BookOpenIcon className="size-6" /> },
};

export type TypePillProps = {
  type: CardType;
};

export function TypePill({ type }: TypePillProps) {
  return (
    <div
      className={clsx('flex w-fit items-center gap-2 rounded-full border px-3 py-1', typePillPropertyMap[type].color)}
    >
      {typePillPropertyMap[type].icon}
      <span className="text-body-bold">{type}</span>
    </div>
  );
}
